<template>
  <div class="million-read-favorite">
    <div class="million-read-favorite-header">
      <div class="million-read-favorite-header-title">我的书架</div>
      <ym-icon v-if="hideSearchBar"
               class="search-icon"
               name="search"
               v-ym-report:MILLION_VIP_MY_BOOKSHELF_SEARCH_CLICK=""
               @click="handleShowSearchBar"
      />
      <div v-else
           class="million-read-favorite-search"
      >
        <div class="million-read-favorite-search-bar">
          <ym-icon class="icon"
                   name="search"
          />
          <form  action=""
                 @submit.prevent="handleSubmit"
          >
            <input class="input"
                   placeholder="输入关键字"
                   type="search"
                   v-model="keyword"
                   ref="searchInput"
                   @keyup.13="hideKeyBoard"
            >
          </form>
        </div>
        <div class="million-read-favorite-search-bar-cancel-btn"
             @click="handleCancelSearch"
        >取消</div>
      </div>
    </div>
    <filter-bar type="millionFavorites"
                :show-manage="hasManage"
                @start-manage-list="handleStartManage"
                @finish-manage-list="handleFinishManage"
                @submit="handleFilterBarSubmit"
    />
    <template v-if="list.length > 0">
      <ym-loadmore v-model="loading"
                   :finished="allLoad"
                   @load="fetchData"
      >
        <book-list :list="list"
                   :show-manage="showManage"
                   :select-all="removeAll"
                   @manage-book="handleSelectBook"
        />
      </ym-loadmore>
    </template>
    <empty-page v-else
                hint="没有相关书籍哦~"
                type="million-read"
    />
    <div v-if="!showManage"
         class="million-read-favorite-select-btn"
         @click="handleLinkToSelect"
    >
      继续选书
      <ym-icon class="icon"
               name="right"
      />
    </div>
    <div v-if="showManage"
         class="million-read-favorite-remove-bar"
    >
      <div class="million-read-favorite-remove-bar-select-all"
           @click="handleSelectAll"
      >
        <ym-icon v-if="removeAll"
                 class="icon"
                 name="mr-remove-favorite"
        />
        <ym-icon v-else
                 class="icon"
                 name="round"
        />
        全选本页
      </div>
      <div class="million-read-favorite-remove-bar-submit-btn"
           @click="handleShowConfirmPopup"
      >
        移出书架<template v-if="selectedIdList.length !== 0">（{{ selectedIdList.length }}）</template>
      </div>
    </div>

    <confirm-popup :show.sync="showConfirmPopup"
                   content="确定要将这些书移出书架吗？"
                   @confirm="handleRemoveBook"
    />
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import { before, decorator } from 'ym-reporter-vue';
  import FilterBar from '@/pages/MillionRead/components/FilterBar';
  import BookList from '@/pages/MillionRead/components/BookList';
  import EmptyPage from '@/components/EmptyPage';
  import ConfirmPopup from '@/pages/MillionRead/components/ConfirmPopup';
  import { getFavoriteExplore, favoriteRemove } from '@/services/million-read';
  import { LIMIT } from '@/utils/constant';
  import { locationHref, handleNoticeAppRefreshEvent } from '@/utils';

  export default {
    name: 'MillionReadFavorite',
    metaInfo() {
      return {
        title: '',
      };
    },
    components: {
      'ym-loadmore': Loadmore,
      FilterBar,
      BookList,
      EmptyPage,
      ConfirmPopup,
    },
    data() {
      return {
        list: [],
        start: 0,
        loading: false,
        allLoad: false,

        keyword: '',
        query: null,
        filterResult: null,
        hideSearchBar: true,

        showManage: false,
        selectedIdList: [],
        removeAll: false,

        showConfirmPopup: false,
        render: {
          appSelectPath: '',
        },
      };
    },
    computed: {
      hasManage() {
        return this.list.length !== 0;
      },
    },
    methods: {
      resetManageStatus() {
        this.showManage = false;
        this.selectedIdList = [];
        this.removeAll = false;
      },
      handleLinkToSelect() {
        if (this.render.appSelectPath && this.render.appSelectPath !== '') {
          locationHref(this.render.appSelectPath);
          return;
        }
        this.$router.push({
          name: 'MillionReadSelect',
        });
      },
      initData() {
        this.list = [];
        this.start = 0;
        this.allLoad = false;
      },
      @decorator(before(function (params) {
        this.$reporter.report('MILLION_VIP_MY_BOOKSHELF_FILTER_CLICK', {
          params,
          type: 'myBookshelf',
        });
      }))
      handleFilterBarSubmit(params) {
        this.initData();
        this.filterResult = params;
        this.fetchData();
      },
      async fetchData() {
        if (this.allLoad) return;
        const params = Object.assign({
          start: this.start,
          limit: LIMIT,
          keyword: this.keyword,
        }, this.filterResult, this.query);

        this.loading = true;
        const data = await getFavoriteExplore(params);
        this.render = data.render;
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.resetManageStatus();
        this.loading = false;
      },
      handleCancelSearch() {
        this.hideSearchBar = true;
      },
      hideKeyBoard() {
        this.$refs.searchInput.blur();
      },
      handleSubmit() {
        this.initData();
        this.fetchData();
      },
      handleShowSearchBar() {
        this.hideSearchBar = false;
      },
      handleStartManage() {
        this.showManage = true;
      },
      handleFinishManage() {
        this.showManage = false;
      },
      handleSelectBook(id) {
        const exist = this.selectedIdList.includes(id);
        if (!exist) {
          this.selectedIdList.push(id);
          return;
        }
        const index = this.selectedIdList.findIndex(item => item === id);
        this.selectedIdList.splice(index, 1);
      },
      handleSelectAll() {
        if (this.removeAll) {
          this.selectedIdList = [];
          this.removeAll = false;
          return;
        }
        this.list.forEach((item) => {
          this.selectedIdList.push(item.id);
        });
        this.removeAll = true;
      },
      async handleRemoveBook() {
        await favoriteRemove(this.selectedIdList);
        handleNoticeAppRefreshEvent('BookShelfRefresh');
        window.location.reload();
      },
      handleShowConfirmPopup() {
        if (this.selectedIdList.length === 0) return;
        this.showConfirmPopup = true;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-favorite {
    position: relative;
    min-height: 100%;
    padding-bottom: 80px;
    background: @color-white;

    &-header {
      box-sizing: border-box;
      padding: @size-extra-medium @size-base @size-base @size-base;
      height: 144px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .search-icon {
        margin-bottom: @size-extra-small;
        color: @color-text-lighter;
        font-size: @size-medium;
      }

      &-title {
        color: @color-text-base;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-bold;
        line-height: 1;
      }
    }

    &-search {
      box-sizing: border-box;
      width: 460px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-search-bar {
      box-sizing: border-box;
      width: 400px;
      height: 64px;
      padding-left: @size-base;
      display: flex;
      align-items: center;
      background: #f5f5fa;
      border-radius: 20px;

      .icon {
        color: #a1a1b3;
        font-size: @font-size-base;
      }
      .input {
        flex: 1;
        height: 64px;
        color: #a1a1b3;
        font-size: 26px;
        background: none;
        padding-left: 6px;
        border: none;
        resize: none;
        outline-offset: 0;
        overflow: hidden;
        outline: none;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
      }
      &-cancel-btn {
        margin-left: @size-base / 2;
        word-break: keep-all;
      }
    }

    &-select-btn {
      width: 100%;
      margin-top: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #6c6c80;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      .icon {
        font-size: 24px;
      }
    }
    &-remove-bar {
      position: fixed;
      bottom: 0;
      left: 50%;
      margin-left: -375px;
      box-sizing: border-box;
      width: 750px;
      height: 110px;
      padding: 0 @size-base;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: @color-white;
      box-shadow: 0 -2px 4px 0px #eee;

      &-select-all {
        display: flex;
        align-items: center;
        color: @color-text-light;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        .icon {
          margin-right: 8px;
          color: #ccc;
          font-size: @font-size-large;
        }
      }
      &-submit-btn {
        color: #ff3434;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
      }
    }
  }

</style>
